var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6364 0.813965H3.36364C1.50523 0.813965 0 2.32196 0 4.1838V34.5123C0 36.3741 1.50523 37.8821 3.36364 37.8821H20.1818V22.7179H15.1364V17.6631H20.1818V14.9487C20.1818 9.80973 22.681 7.55363 26.9444 7.55363C28.9861 7.55363 30.0659 7.70527 30.5771 7.77435V12.6084H27.6693C25.8596 12.6084 25.2273 13.5654 25.2273 15.5031V17.6631H30.5317L29.8119 22.7179H25.2273V37.8821H33.6364C35.4948 37.8821 37 36.3741 37 34.5123V4.1838C37 2.32196 35.4931 0.813965 33.6364 0.813965Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDesktop);
export default __webpack_public_path__ + "static/media/facebook_desktop.c7566bfb.svg";
export { ForwardRef as ReactComponent };